import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { share, shareReplay, tap } from 'rxjs';
import { env } from 'echarts';

@Injectable({
  providedIn: 'root'
})
export class MembershipService {

  constructor(private http:HttpClient) { }

  getMembershipData(){
    return this.http.get(`${environment.operational_url}Operational/getMembershipTiers`).pipe(
    // return this.http.get(`http://192.168.18.60:8000/operational/api/v1/Operational/getMembershipTiers`).pipe(
      tap((response:any)=>{ }),
      shareReplay()
    )
  }

  subscribeMembership(payload:any){
    console.log('this is the payload in checkout id')
    return this.http.post(`${environment.operational_url}Operational/memberShipCheckoutUrl`,payload).pipe(
      tap((response:any)=>{}),
      shareReplay()
    )
  }

  getmembershipdescription(){
    return this.http.get(`${environment.operational_url}Operational/membershipContent`)
  }


  userMembershipDetials(){
    return this.http.get(`${environment.operational_url}Operational/getUserMemberShipDetails`)
  }

  cancelMembership(){
    return this.http.post(`${environment.operational_url}Operational/cancelMembership`,{}).pipe(
      tap((response:any)=>{}),
      shareReplay()
    )
  }


  getsubscriptionStatus(paylaod:any){
    return this.http.post(`${environment.operational_url}operational/verifyMembershipSession`,paylaod).pipe(
      tap((response:any)=>{}),
      shareReplay()
    )
  }

  postTrailService(payload:any){
    return this.http.post(`${environment.operational_url}operational/requestTrialMembership`,payload).pipe(
      tap((response:any)=>{}),
      shareReplay()
    )
  }
  postSignupandtrial(payload:any){
    return this.http.post(`${environment.operational_url}operational/verifyOTPAndActivateTrial`, payload).pipe(
      tap((response:any)=>{
        shareReplay()
      })
    )
  }

}
